import { Box, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

type Props = {
  title: string
  text: string
}

const useStyles = makeStyles<{ containerHeight: number }>()((theme, { containerHeight }) => ({
  step: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    width: '100%',

    '& > .content': {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(1.3, 2),
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.grey.grey06}`,
      background: theme.palette.grey.grey07,
      width: '100%',
    },

    '& > .circle-icon': {
      width: 12,
      minWidth: 12,
      height: 12,
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: '50%',
      background: theme.palette.common.white,
      position: 'relative',

      '&::before, &::after': {
        content: '""',
        position: 'absolute',
        width: 2,
        height: `calc(${containerHeight / 2}px + 12px)`,
        backgroundColor: theme.palette.primary.main,
        left: '50%',
        transform: 'translateX(-50%)',
      },

      '&::before': {
        bottom: '100%',
      },

      '&::after': {
        top: '100%',
      },
    },

    '&:first-of-type': {
      '& > .circle-icon::before': {
        display: 'none',
      },
    },
    '&:last-of-type': {
      '& > .circle-icon::after': {
        display: 'none',
      },
    },
  },
}))
/*
 * This component is used to display a single step of the referral process.
 */
const Step: React.FC<Props> = ({ title, text }) => {
  const ref = useRef<null | HTMLLIElement>(null)
  const [containerHeight, setContainerHeight] = useState<number>(0)
  const { classes } = useStyles({ containerHeight })

  const updateContainerHeight = (): void => {
    if (ref.current) {
      setContainerHeight(ref.current.clientHeight)
    }
  }

  useEffect(() => {
    updateContainerHeight()

    window.addEventListener('resize', updateContainerHeight)

    return () => {
      window.removeEventListener('resize', updateContainerHeight)
    }
  }, [])

  return (
    <Box component="li" ref={ref} className={classes.step}>
      <Box component="span" className="circle-icon" />
      <Box className="content">
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="caption">{text}</Typography>
      </Box>
    </Box>
  )
}

export default Step
